import {Component, Input, ChangeDetectionStrategy, OnInit, Inject} from '@angular/core';

import {SafeHtml} from '@angular/platform-browser';
import {AsyncPipe} from '@angular/common';
import {Observable} from 'rxjs';
import {ICON_REGISTRY_SERVICE, IconRegistry} from './svg-icon.providers';

@Component({
  selector: 'app-icon',
  template: `<span class="icon" [innerHTML]="svg$ | async"></span>`,
  styles: [
    `
      .icon svg {
        fill: currentColor; /* <-- allows CSS color control */
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class SvgIconComponent implements OnInit {
  @Input() name!: string;

  svg$!: Observable<SafeHtml> | undefined;

  constructor(@Inject(ICON_REGISTRY_SERVICE) private iconRegistry: IconRegistry) {}

  ngOnInit() {
    this.svg$ = this.iconRegistry.getIcon(this.name);
  }
}
